import { Company } from '@domain/company';
import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants.type';

const getUserCompanies = async (clubId: string) => {
  const url = `${import.meta.env.VITE_MONOLITH_HOST}/v1/me/clubs/${clubId}/companies`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetUserCompanies = (clubId: string) => {
  return useGenericQuery<Company[], RequestError>([QUERY_KEYS.getCompanies, clubId], () => getUserCompanies(clubId), {
    enabled: !!clubId,
  });
};
